import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/legal/datenschutz")({
  head: () => ({ meta: [{ title: "Datenschutz — NexKey.gg" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <article>
      <h1 className="font-display text-3xl font-bold">Datenschutzerklärung</h1>
      <p className="mt-4 text-sm text-muted-foreground">
        Placeholder. Replace with a GDPR-compliant privacy policy covering server logs, cookies,
        analytics and affiliate tracking before going live.
      </p>
    </article>
  ),
});
